// Parent mode's clock (B8, WI-17): a grown-up on a child's phone hands it back after 30 minutes
// without a touch, with a warning in the last minute. Time while a sheet or the plan is open
// doesn't count (the caller keeps touching), and the last touch survives a reload.

/**
 * Parent mode lasts this many minutes without a touch (K1, the 23 Oct run's default: 30, the same
 * as the server's parent session, worker/session.ts PARENT_SESSION_MS). Every string uses it.
 */
export const PARENT_MODE_MINUTES = 30
/** Parent mode ends after this long without a touch. */
export const PARENT_MODE_IDLE_MS = PARENT_MODE_MINUTES * 60_000
/** The banner warns from here on (the last minute). */
export const PARENT_MODE_WARN_MS = PARENT_MODE_IDLE_MS - 60_000

export interface ParentModeClock {
  /** Milliseconds until the phone goes back to the child. */
  left: number
  /** Whole minutes left, rounded up (what the banner says). */
  minutesLeft: number
  /** In the last minute. */
  warn: boolean
  /** Time's up: hand the phone back. */
  over: boolean
}

export function parentModeClock(lastTouch: number, now: number): ParentModeClock {
  const idle = Math.max(0, now - lastTouch)
  const left = Math.max(0, PARENT_MODE_IDLE_MS - idle)
  return { left, minutesLeft: Math.ceil(left / 60_000), warn: left > 0 && idle >= PARENT_MODE_WARN_MS, over: left === 0 }
}
